import React from "react";
import { Loader } from "semantic-ui-react";
export default function fallbackUI() {
  return (
    <center style={{ position: "relative", top: "30vh" }}>
      Preparing Entry Release &amp; Summary{" "}
      <Loader indeterminate active inline size="small" />
    </center>
  );
}
